<div>
  <app-bottom-dialog [iconName]="'diamond'" [title]="'Das ist ein Premium-Feature'" [isVisible]="isVisible" (actionCancelled)="isVisible = false">
    <div class="dialog-content">
      <h2>{{title}}</h2>
      <p>{{text}}</p>
      
      <!--<h2>Weitere Premium-Vorteile</h2>
      <div class="benefits-list">
        <div class="benefit">
          <i-tabler name="circle-check"></i-tabler>
          <span>Schalte alle Lernmodi frei</span>
        </div>
        <div class="benefit">
          <i-tabler name="circle-check"></i-tabler>
          <span>Teste dein Wissen mit KI-Probeklausuren</span>
        </div>
        <div class="benefit">
          <i-tabler name="circle-check"></i-tabler>
          <span>Nie wieder Lernlücken dank smarten Karteikarten-Vorschlägen</span>
        </div>
      </div>-->

      <app-button [text]="'Alle Premium-Vorteile ansehen'" (clickEvent)="openGetPremium()"></app-button>
    </div>
  </app-bottom-dialog>
</div>